/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import DestinationGroup from "../components/DestinationGroup.jsx";
import { displayModuleType } from "../ModuleType";

export default class Advanced extends React.Component {
  getServiceNumbers = () => {
    const ddiList = this.props.service.ddiList.map((o, i) => {
      return (
        <SectionItem key={i} itemKey="">
          <p className={o.supplierId === 3 ? "auroraNumber" : ""}>
            {o.ddi}
            {o.serviceTypeDescription
              ? ` (${o.serviceTypeDescription})`
              : o.serviceTypeDescription}
          </p>
        </SectionItem>
      );
    });
    return <span>{ddiList}</span>;
  };

  destinationGroups = (service) => {
    const destinationGroupList = service.moduleList
      .filter((o) => o.moduleType === "DESTINATION_GROUP")
      .map((o, i) => {
        return (
          <SummaryItem key={i} itemKey={`${o.name || "Destination"}:`}>
            <DestinationGroup
              group={o}
              sites={this.props.sites}
              clientId={this.props.clientId}
            />
          </SummaryItem>
        );
      });
    return <span>{destinationGroupList}</span>;
  };

  boltOns = (service) => {
    const boltOnList = service.moduleList
      .filter((o) => o.moduleType !== "DESTINATION_GROUP")
      .filter((o) => typeof displayModuleType[o.moduleType] === "string")
      .sort((a, b) =>
        a.moduleType < b.moduleType ? -1 : a.moduleType > b.moduleType ? 1 : 0,
      )
      .map((o, i) => {
        return (
          <SectionItem key={i} itemKey="">
            {displayModuleType[o.moduleType]}{" "}
          </SectionItem>
        );
      });
    return <span>{boltOnList}</span>;
  };

  enhancedBoltOns = (service) => {
    const boltOnList = service.moduleList
      .filter((o) => o.moduleType !== "DESTINATION_GROUP")
      .filter((o) => typeof displayModuleType[o.moduleType] !== "string")
      .sort((a, b) =>
        a.moduleType < b.moduleType ? -1 : a.moduleType > b.moduleType ? 1 : 0,
      )
      .map((o) =>
        displayModuleType[o.moduleType](
          o,
          this.props.sites,
          this.props.clientId,
        ),
      );
    return <span>{boltOnList}</span>;
  };

  render = () => {
    const { service: propService, isSubLevel } = this.props;
    let service = propService;
    if (typeof propService === "string") {
      service = JSON.parse(propService);
    }
    return (
      <div
        className={`ui-layout-content content serviceConfig-container ${isSubLevel ? "subServiceConfig-container" : ""}`}
      >
        <div className="section-body">
          <SectionItem itemKey="Service Name">{service.name}</SectionItem>
        </div>
        {service.ddiList.length > 0 && (
          <SummaryItem itemKey="Number(s):">
            {this.getServiceNumbers()}
          </SummaryItem>
        )}
        {this.destinationGroups(service)}
        {service.moduleList
          .filter((o) => o.moduleType !== "DESTINATION_GROUP")
          .filter((o) => typeof displayModuleType[o.moduleType] !== "string")
          .length > 0 && this.enhancedBoltOns(service)}
        {service.moduleList
          .filter((o) => o.moduleType !== "DESTINATION_GROUP")
          .filter((o) => typeof displayModuleType[o.moduleType] === "string")
          .length > 0 && (
          <SummaryItem itemKey="Other additional features: ">
            {this.boltOns(service)}
          </SummaryItem>
        )}
      </div>
    );
  };
}

Advanced.propTypes = {
  jwt: PropTypes.string,
  service: PropTypes.array,
  sites: PropTypes.object,
  serviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isSubLevel: PropTypes.bool,
};
